import React, { useState } from 'react';
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import { Card, CardContent, Grid, TextField, FormControl, InputLabel, Select, MenuItem, Button, Typography } from '@material-ui/core';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Authapi from '../../Services/Authapi';
import swal from 'sweetalert';
import AuthCheckComponent from '../../Layouts/Token';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';

export default function Reviewformadd(props) {
    const [doc, setDoc] = useState({
        title: '',
        inputs: [{ type: '', label: '', options: [] }]
    });
    const [postTitles, setPostTitles] = useState([{ title: '', inputs: [{ type: '', label: '' }] }]);
    const [formErrors, setFormErrors] = useState({});
    const classes = {};

    const getMainLabelErrorKey = (inputIndex) => `main_label_${inputIndex}`;
    const getMainTypeErrorKey = (inputIndex) => `main_type_${inputIndex}`;
    const getMainOptionErrorKey = (inputIndex, optionIndex) => `main_option_${inputIndex}_${optionIndex}`;
    const getMainOptionsGroupErrorKey = (inputIndex) => `main_options_group_${inputIndex}`;
    const getPostTitleErrorKey = (postIndex) => `post_title_${postIndex}`;
    const getPostInputLabelErrorKey = (postIndex, inputIndex) => `post_label_${postIndex}_${inputIndex}`;
    const getPostInputTypeErrorKey = (postIndex, inputIndex) => `post_type_${postIndex}_${inputIndex}`;
    const getPostOptionErrorKey = (postIndex, inputIndex, optionIndex) => `post_option_${postIndex}_${inputIndex}_${optionIndex}`;
    const getPostOptionsGroupErrorKey = (postIndex, inputIndex) => `post_options_group_${postIndex}_${inputIndex}`;
    const getNormalizedLabel = (item = {}) => item.label || item.input_label || item.content_label || item.name || '';
    const getNormalizedTitle = (item = {}) => item.title || item.form_title || '';

    const clearError = (key) => {
        setFormErrors((prevState) => {
            if (!prevState[key]) {
                return prevState;
            }

            const updatedErrors = { ...prevState };
            delete updatedErrors[key];
            return updatedErrors;
        });
    };

    const validateForm = () => {
        const errors = {};

        if (!doc.title.trim()) {
            errors.title = "Form name is required";
        }

        doc.inputs.forEach((input, inputIndex) => {
            if (!input.label?.trim()) {
                errors[getMainLabelErrorKey(inputIndex)] = "Input label is required";
            }

            if (!input.type?.trim()) {
                errors[getMainTypeErrorKey(inputIndex)] = "Input type is required";
            }

            if (input.type === 'radio' || input.type === 'checkbox') {
                const validOptions = (input.options || []).filter((option) => option?.trim());
                if (validOptions.length === 0) {
                    errors[getMainOptionsGroupErrorKey(inputIndex)] = "At least one option is required";
                }

                (input.options || []).forEach((option, optionIndex) => {
                    if (!option?.trim()) {
                        errors[getMainOptionErrorKey(inputIndex, optionIndex)] = "Option is required";
                    }
                });
            }
        });

        postTitles.forEach((postTitle, postIndex) => {
            if (!postTitle.title?.trim()) {
                errors[getPostTitleErrorKey(postIndex)] = "Form title is required";
            }

            postTitle.inputs.forEach((input, inputIndex) => {
                if (!input.label?.trim()) {
                    errors[getPostInputLabelErrorKey(postIndex, inputIndex)] = "Input label is required";
                }

                if (!input.type?.trim()) {
                    errors[getPostInputTypeErrorKey(postIndex, inputIndex)] = "Input type is required";
                }

                if (input.type === 'radio' || input.type === 'checkbox') {
                    const validOptions = (input.options || []).filter((option) => option?.trim());
                    if (validOptions.length === 0) {
                        errors[getPostOptionsGroupErrorKey(postIndex, inputIndex)] = "At least one option is required";
                    }

                    (input.options || []).forEach((option, optionIndex) => {
                        if (!option?.trim()) {
                            errors[getPostOptionErrorKey(postIndex, inputIndex, optionIndex)] = "Option is required";
                        }
                    });
                }
            });
        });

        return errors;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const errors = validateForm();
        setFormErrors(errors);
        if (Object.keys(errors).length > 0) {
            return;
        }
        createLeaves();
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setDoc(prevState => ({
            ...prevState,
            [name]: value
        }));
        clearError(name);
    };

    const handleMainInputChange = (inputIndex, field, value) => {
        const newInputs = [...doc.inputs];
        newInputs[inputIndex][field] = value;
        if (field === 'type' && (value === 'radio' || value === 'checkbox')) {
            newInputs[inputIndex].options = newInputs[inputIndex].options || []; // Initialize options if type is radio or checkbox
        } else if (field === 'type') {
            newInputs[inputIndex].options = [];
        }
        setDoc(prevState => ({
            ...prevState,
            inputs: newInputs
        }));
        if (field === 'label') {
            clearError(getMainLabelErrorKey(inputIndex));
        }
        if (field === 'type') {
            clearError(getMainTypeErrorKey(inputIndex));
            clearError(getMainOptionsGroupErrorKey(inputIndex));
        }
    };

    const handleOptionChange = (inputIndex, optionIndex, value) => {
        const newInputs = [...doc.inputs];
        newInputs[inputIndex].options[optionIndex] = value;
        setDoc(prevState => ({
            ...prevState,
            inputs: newInputs
        }));
        clearError(getMainOptionErrorKey(inputIndex, optionIndex));
        clearError(getMainOptionsGroupErrorKey(inputIndex));
    };

    const addOption = (inputIndex) => {
        setDoc(prevState => {
            const newInputs = [...prevState.inputs];
            if (!newInputs[inputIndex]) {
                newInputs[inputIndex] = { type: '', label: '', options: [] };
            }
            newInputs[inputIndex].options = newInputs[inputIndex].options || [];
            newInputs[inputIndex].options.push(''); // Add a new empty option
            return { ...prevState, inputs: newInputs };
        });
    };

    const removeOption = (inputIndex, optionIndex) => {
        const newInputs = [...doc.inputs];
        newInputs[inputIndex].options.splice(optionIndex, 1);
        setDoc(prevState => ({
            ...prevState,
            inputs: newInputs
        }));
    };

    const addMainInputField = () => {
        setDoc(prevState => ({
            ...prevState,
            inputs: [...prevState.inputs, { type: '', label: '', options: [] }]
        }));
    };

    const removeMainInputField = (inputIndex) => {
        const newInputs = [...doc.inputs];
        newInputs.splice(inputIndex, 1);
        setDoc(prevState => ({
            ...prevState,
            inputs: newInputs
        }));
    };

    const handlePostTitleChange = (index, value) => {
        const newPostTitles = [...postTitles];
        newPostTitles[index].title = value;
        setPostTitles(newPostTitles);
        clearError(getPostTitleErrorKey(index));
    };

    const handleInputChange = (postIndex, inputIndex, field, value) => {
        const newPostTitles = [...postTitles];
        if (field === 'options') {
            newPostTitles[postIndex].inputs[inputIndex][field] = value.split(',').map(option => option.trim());
        } else {
            newPostTitles[postIndex].inputs[inputIndex][field] = value;
            if (field === 'type' && (value !== 'radio' && value !== 'checkbox')) {
                newPostTitles[postIndex].inputs[inputIndex].options = [];
            }
        }
        setPostTitles(newPostTitles);
        if (field === 'label') {
            clearError(getPostInputLabelErrorKey(postIndex, inputIndex));
        }
        if (field === 'type') {
            clearError(getPostInputTypeErrorKey(postIndex, inputIndex));
            clearError(getPostOptionsGroupErrorKey(postIndex, inputIndex));
        }
    };

    const addPostTitleField = () => {
        setPostTitles([...postTitles, { title: '', inputs: [{ type: '', label: '' }] }]);
    };

    const removePostTitleField = (index) => {
        const newPostTitles = [...postTitles];
        newPostTitles.splice(index, 1);
        setPostTitles(newPostTitles);
    };

    const addInputField = (postIndex) => {
        const newPostTitles = [...postTitles];
        newPostTitles[postIndex].inputs.push({ type: '', label: '' });
        setPostTitles(newPostTitles);
    };

    const removeInputField = (postIndex, inputIndex) => {
        const newPostTitles = [...postTitles];
        newPostTitles[postIndex].inputs.splice(inputIndex, 1);
        setPostTitles(newPostTitles);
    };

    const handlePostOptionChange = (postIndex, inputIndex, optionIndex, value) => {
        const newPostTitles = [...postTitles];
        newPostTitles[postIndex].inputs[inputIndex].options[optionIndex] = value;
        setPostTitles(newPostTitles);
        clearError(getPostOptionErrorKey(postIndex, inputIndex, optionIndex));
        clearError(getPostOptionsGroupErrorKey(postIndex, inputIndex));
    };

    const addPostOption = (postIndex, inputIndex) => {
        setPostTitles(prevState => {
            const newPostTitles = [...prevState];
            const input = newPostTitles[postIndex].inputs[inputIndex];
            input.options = input.options || [];
            input.options.push('');
            return newPostTitles;
        });
    };

    const removePostOption = (postIndex, inputIndex, optionIndex) => {
        const newPostTitles = [...postTitles];
        newPostTitles[postIndex].inputs[inputIndex].options.splice(optionIndex, 1);
        setPostTitles(newPostTitles);
    };

    const createLeaves = async () => {
        swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            width: "10%",
            content: createSwalLoaderNode()
        });

        try {
            const transformedInputs = doc.inputs.map(input => ({
                label: getNormalizedLabel(input),
                input_label: getNormalizedLabel(input),
                type: input.type,
                options: (input.type === 'radio' || input.type === 'checkbox') ? input.options : []
            }));

            const transformedPostTitles = postTitles.map(postTitle => {
                return postTitle.inputs.map(input => ({
                    title: getNormalizedTitle(postTitle),
                    form_title: getNormalizedTitle(postTitle),
                    label: getNormalizedLabel(input),
                    content_label: getNormalizedLabel(input),
                    type: input.type,
                    options: (input.type === 'radio' || input.type === 'checkbox') ? input.options : []
                }));
            }).flat();

            const postData = {
                form_name: doc.title,
                form_details: transformedInputs,
                form_content: transformedPostTitles
            };

            let create = await Authapi.Reviewformadd(postData);
            swal.close();
            if (create && create.status === true) {
                swal("Success", "Review form added successfully", "success").then(() => {
                    props.history.push("/review-form-list");
                });
            } else {
                swal({
                    title: "OOPS!",
                    icon: "error",
                    text: create && create.message ? create.message : "Something went wrong, Please try later!",
                });
            }
        } catch (error) {
            swal.close();
            console.error("Error updating role:", error);
            swal("Error", "An unexpected error occurred", "error");
        }
    };




    return (
        <div>
            <AuthCheckComponent authToken={props.authToken} />
            <Header
                {...props}
                authUser={props.authUser}
                setAuthUser={props.setAuthUser}
                component={
                    <div>
                        <Card className={classes.root} style={{ marginBottom: '3%' }}>
                            <CardContent>
                                <Breadcrumb {...props}
                                    primaryPageName="Generate Form"
                                    primaryPageLink="/dashboard"
                                    isSecondaryPage={false}
                                    secondaryPageName="" />
                            </CardContent>
                        </Card>
                        <Grid container className={classes.root} spacing={2}>
                            <Grid item xs={12}>
                                <Card className={classes.root}>
                                    <CardContent>
                                        <Typography variant="h2" className="common-form-page-title" style={{ paddingTop: 0, paddingLeft: 0, paddingBottom: 0 }}>Generate Form</Typography>
                                        <form className={classes.form} onSubmit={handleSubmit}>
                                            <Grid container className={classes.root} spacing={5}>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        id="outlined-basic"
                                                        label="Name"
                                                        name="title"
                                                        variant="outlined"
                                                        InputLabelProps={{ shrink: true }}
                                                        error={formErrors.title && true}
                                                        value={doc.title}
                                                        onChange={handleChange}
                                                        className={formErrors.title && "input-error"}
                                                    />
                                                    {formErrors.title && (
                                                        <span className="error">{formErrors.title}</span>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            {doc.inputs.map((input, inputIndex) => (
                                                <Grid container spacing={2} key={inputIndex}>
                                                    <Grid item xs={5}>
                                                    <TextField
                                                        fullWidth
                                                        label={`Input Label ${inputIndex + 1}`}
                                                        InputLabelProps={{ shrink: true }}
                                                        value={input.label}
                                                        onChange={(e) => handleMainInputChange(inputIndex, 'label', e.target.value)}
                                                        error={Boolean(formErrors[getMainLabelErrorKey(inputIndex)])}
                                                        helperText={formErrors[getMainLabelErrorKey(inputIndex)] || ''}
                                                    />
                                                </Grid>
                                                    <Grid item xs={5}>
                                                        <FormControl fullWidth error={Boolean(formErrors[getMainTypeErrorKey(inputIndex)])}>
                                                            <InputLabel>Input Type</InputLabel>
                                                            <Select
                                                                value={input.type}
                                                                onChange={(e) => handleMainInputChange(inputIndex, 'type', e.target.value)}
                                                            >
                                                                <MenuItem value="text">Text</MenuItem>
                                                                <MenuItem value="date">Date</MenuItem>
                                                                <MenuItem value="email">Email</MenuItem>
                                                                <MenuItem value="number">Number</MenuItem>
                                                                <MenuItem value="textarea">Textarea</MenuItem>
                                                                <MenuItem value="checkbox">Checkbox</MenuItem>
                                                                <MenuItem value="radio">Radio</MenuItem>
                                                            </Select>
                                                            {formErrors[getMainTypeErrorKey(inputIndex)] && (
                                                                <span className="error">{formErrors[getMainTypeErrorKey(inputIndex)]}</span>
                                                            )}
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Button
                                                            type="button"
                                                            onClick={() => removeMainInputField(inputIndex)}
                                                            variant="contained"
                                                            style={{
                                                                color: "#fff",
                                                                backgroundColor: "#d12c2c",
                                                                marginTop: "10px",
                                                                textTransform: 'capitalize'
                                                            }}>
                                                            Remove
                                                        </Button>
                                                    </Grid>
                                                    {(input.type === 'radio' || input.type === 'checkbox') && (
                                                        <>

                                                            <Grid item xs={12}>
                                                                {input.options && input.options.map((option, optionIndex) => (
                                                                    <Grid container spacing={2} key={optionIndex}>
                                                                        <Grid item xs={8}>
                                                                            <TextField
                                                                                fullWidth
                                                                                label={`Option ${optionIndex + 1}`}
                                                                                InputLabelProps={{ shrink: true }}
                                                                                value={option}
                                                                                onChange={(e) => handleOptionChange(inputIndex, optionIndex, e.target.value)}
                                                                                error={Boolean(formErrors[getMainOptionErrorKey(inputIndex, optionIndex)])}
                                                                                helperText={formErrors[getMainOptionErrorKey(inputIndex, optionIndex)] || ''}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={2}>
                                                                            <Button
                                                                                type="button"
                                                                                onClick={() => removeOption(inputIndex, optionIndex)}
                                                                                variant="contained"
                                                                                style={{
                                                                                    color: "#fff",
                                                                                    backgroundColor: "#d12c2c",
                                                                                    marginTop: "10px",
                                                                                    textTransform: 'capitalize'
                                                                                }}>
                                                                                Remove
                                                                            </Button>
                                                                        </Grid>
                                                                    </Grid>
                                                                ))}
                                                                <Button
                                                                    type="button"
                                                                    onClick={() => addOption(inputIndex)}
                                                                    variant="contained"
                                                                    color="primary"
                                                                    style={{ marginTop: "10px", textTransform: 'capitalize' }}>
                                                                    Add Option
                                                                </Button>
                                                                {formErrors[getMainOptionsGroupErrorKey(inputIndex)] && (
                                                                    <span className="error">{formErrors[getMainOptionsGroupErrorKey(inputIndex)]}</span>
                                                                )}
                                                            </Grid>
                                                        </>
                                                    )}
                                                </Grid>
                                            ))}
                                            <Button
                                                type="button"
                                                onClick={addMainInputField}
                                                variant="contained"
                                                color="primary"
                                                className="common-action-button"
                                                style={{ marginTop: "10px", textTransform: 'capitalize' }}>
                                                Add Input
                                            </Button>
                                            {postTitles.map((postTitle, postIndex) => (
                                                <div key={postIndex}>
                                                    <Grid container spacing={5}>
                                                        <Grid item xs={10}>
                                                            <TextField
                                                                fullWidth
                                                                label={`Form Title ${postIndex + 1}`}
                                                                InputLabelProps={{ shrink: true }}
                                                                value={postTitle.title}
                                                                onChange={(e) => handlePostTitleChange(postIndex, e.target.value)}
                                                                error={Boolean(formErrors[getPostTitleErrorKey(postIndex)])}
                                                                helperText={formErrors[getPostTitleErrorKey(postIndex)] || ''}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={2}>
                                                            <Button
                                                                type="button"
                                                                onClick={() => removePostTitleField(postIndex)}
                                                                variant="contained"
                                                                style={{
                                                                    color: "#fff",
                                                                    backgroundColor: "#d12c2c",
                                                                    marginTop: "10px",
                                                                    textTransform: 'capitalize'
                                                                }}>
                                                                Remove
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                    {postTitle.inputs.map((input, inputIndex) => (
                                                        <Grid container spacing={2} key={inputIndex}>
                                                            <Grid item xs={5}>
                                                                <TextField
                                                                    fullWidth
                                                                    label={`Input Label ${inputIndex + 1}`}
                                                                    InputLabelProps={{ shrink: true }}
                                                                    value={input.label}
                                                                    onChange={(e) => handleInputChange(postIndex, inputIndex, 'label', e.target.value)}
                                                                    error={Boolean(formErrors[getPostInputLabelErrorKey(postIndex, inputIndex)])}
                                                                    helperText={formErrors[getPostInputLabelErrorKey(postIndex, inputIndex)] || ''}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={5}>
                                                                <FormControl fullWidth error={Boolean(formErrors[getPostInputTypeErrorKey(postIndex, inputIndex)])}>
                                                                    <InputLabel>Input Type</InputLabel>
                                                                    <Select
                                                                        value={input.type}
                                                                        onChange={(e) => handleInputChange(postIndex, inputIndex, 'type', e.target.value)}
                                                                    >
                                                                        <MenuItem value="text">Text</MenuItem>
                                                                        <MenuItem value="date">Date</MenuItem>
                                                                        <MenuItem value="email">Email</MenuItem>
                                                                        <MenuItem value="number">Number</MenuItem>
                                                                        <MenuItem value="textarea">Textarea</MenuItem>
                                                                        <MenuItem value="checkbox">Checkbox</MenuItem>
                                                                        <MenuItem value="radio">Radio</MenuItem>
                                                                    </Select>
                                                                    {formErrors[getPostInputTypeErrorKey(postIndex, inputIndex)] && (
                                                                        <span className="error">{formErrors[getPostInputTypeErrorKey(postIndex, inputIndex)]}</span>
                                                                    )}
                                                                </FormControl>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                <Button
                                                                    type="button"
                                                                    onClick={() => removeInputField(postIndex, inputIndex)}
                                                                    variant="contained"
                                                                    style={{
                                                                        color: "#fff",
                                                                        backgroundColor: "#d12c2c",
                                                                        marginTop: "10px",
                                                                        textTransform: 'capitalize'
                                                                    }}>
                                                                    Remove
                                                                </Button>
                                                            </Grid>
                                                            {(input.type === 'radio' || input.type === 'checkbox') && (
                                                                <Grid item xs={12}>
                                                                    {input.options && input.options.map((option, optionIndex) => (
                                                                        <Grid container spacing={2} key={optionIndex}>
                                                                            <Grid item xs={8}>
                                                                                <TextField
                                                                                    fullWidth
                                                                                    label={`Option ${optionIndex + 1}`}
                                                                                    InputLabelProps={{ shrink: true }}
                                                                                    value={option}
                                                                                    onChange={(e) => handlePostOptionChange(postIndex, inputIndex, optionIndex, e.target.value, "")}
                                                                                    error={Boolean(formErrors[getPostOptionErrorKey(postIndex, inputIndex, optionIndex)])}
                                                                                    helperText={formErrors[getPostOptionErrorKey(postIndex, inputIndex, optionIndex)] || ''}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={2}>
                                                                                <Button
                                                                                    type="button"
                                                                                    onClick={() => removePostOption(postIndex, inputIndex, optionIndex)}
                                                                                    variant="contained"
                                                                                    style={{
                                                                                        color: "#fff",
                                                                                        backgroundColor: "#d12c2c",
                                                                                        marginTop: "10px",
                                                                                        textTransform: 'capitalize'
                                                                                    }}>
                                                                                    Remove
                                                                                </Button>
                                                                            </Grid>
                                                                        </Grid>
                                                                    ))}
                                                                    <Button
                                                                        type="button"
                                                                        onClick={() => addPostOption(postIndex, inputIndex)}
                                                                        variant="contained"
                                                                        color="primary"
                                                                        style={{ marginTop: "10px", textTransform: 'capitalize' }}>
                                                                        Add Option
                                                                    </Button>
                                                                    {formErrors[getPostOptionsGroupErrorKey(postIndex, inputIndex)] && (
                                                                        <span className="error">{formErrors[getPostOptionsGroupErrorKey(postIndex, inputIndex)]}</span>
                                                                    )}
                                                                </Grid>
                                                            )}
                                                        </Grid>
                                                    ))}
                                                    <Button
                                                        type="button"
                                                        onClick={() => addInputField(postIndex)}
                                                        variant="contained"
                                                        color="primary"
                                                        className="common-action-button"
                                                        style={{ marginTop: "10px", textTransform: 'capitalize' }}>
                                                        Add Input
                                                    </Button>
                                                </div>
                                            ))}
                                            <Grid item xs={12} style={{ marginTop: "10px" }}>
                                                <Button type="button" onClick={addPostTitleField} variant="contained" color="primary" className="common-action-button" style={{ textTransform: 'capitalize' }}>
                                                    Add Form Title
                                                </Button>
                                            </Grid>
                                            <Grid container className={classes.root} spacing={3}>
                                                <Grid item xs={4}>
                                                    <Button type="submit" className="btn-success" style={{ marginTop: "10px", float: 'left', marginBottom: "15px", textTransform: 'capitalize' }} variant="contained" color="primary">Save</Button>
                                                    <Button type="button" className="btn-cancel" style={{ marginTop: "10px", float: 'left', marginBottom: "15px", textTransform: 'capitalize' }} onClick={(e) => { e.preventDefault(); props.history.push('/review-form-list') }}>Cancel</Button>
                                                </Grid>
                                            </Grid>
                                        </form>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </div>
                }
            />
            <Footer {...props} />
        </div>
    );
}
